import { Fragment, ReactNode } from 'react';
import { Divider } from '@mui/material';
import {
  Award_Per_Counting_Strategy,
  Earning_Mechanism_Product_Counting_Attribute,
} from '@occc/graphql';
import { InfoFieldRow, InfoFieldRowProps } from '../components';
import type { ProductGroupBasic } from '../component-details.types';

export const isProductGroup = (
  productGroup: ProductGroupBasic | undefined | null,
): productGroup is ProductGroupBasic => !!productGroup;

export const arrangeNodeGroups = (
  nodes: ReactNode[] | ReactNode[][],
  groupCapacity: InfoFieldRowProps['cols'] = 3,
) => {
  return nodes
    .flat(1)
    .filter(Boolean)
    .reduce<ReactNode[][]>((acc, node, i) => {
      const groupIndex = Math.floor(i / groupCapacity);
      if (!acc[groupIndex]) acc[groupIndex] = [];
      acc[groupIndex].push(<Fragment key={i}>{node}</Fragment>);
      return acc;
    }, []);
};

export const renderNodeGroups = (nodeGroups: ReactNode[][], cols?: number, isDivider?: boolean) => {
  return nodeGroups.map((group, i) => (
    <Fragment key={i}>
      <InfoFieldRow cols={cols || group.length || 3}>{group}</InfoFieldRow>
      {isDivider && i < nodeGroups.length - 1 && <Divider />}
    </Fragment>
  ));
};

export const getCountingAttributeLabel = (
  value: Earning_Mechanism_Product_Counting_Attribute | Award_Per_Counting_Strategy,
): string => {
  return {
    [Earning_Mechanism_Product_Counting_Attribute.MoneyAmount]: 'Money Amount',
    [Earning_Mechanism_Product_Counting_Attribute.Quantity]: 'Quantity',
    [Earning_Mechanism_Product_Counting_Attribute.UnitsCount]: 'Selling Unit',
    [Award_Per_Counting_Strategy.TotalPurchase]: 'All Items',
    [Award_Per_Counting_Strategy.IndividualPurchase]: 'Single Item',
    [Award_Per_Counting_Strategy.SellingUnitPurchase]: 'Selling Units',
  }[value];
};
